import { Grid, Typography } from '@mui/material';
import { WithStyles, useTheme, withStyles } from '@mui/styles';
import { BasicButton } from '@tassat/button';
import { PledgeTransactionTypeEnum } from '@tassat/common-definitions';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import { ModalPledgeValues } from './pledgeDetailsModal/pledgeContextWorkflow';
import type { PledgeResultModalProps } from './pledgeResultModal';
import { muiStyles } from './pledgeResultStyles';

interface PledgeResultFailedProps extends WithStyles<typeof muiStyles> {
    modalPledgeValues: ModalPledgeValues | null;
    pledgeType: PledgeResultModalProps['pledgeType'];
    onClose: () => void;
}

export function PledgeResultFailedComponent (props: PledgeResultFailedProps) {
    const {
        classes,
        modalPledgeValues,
        pledgeType,
        onClose
    } = props;

    const theme = useTheme<ApplicationMuiTheme>();

    const {
        email = 'tassatpaysupport@tassatpay.com',
        phoneDirect,
        phoneTollFree
    } = theme?.app?.clientTheme.support.contactInfo || {};

    const fromApproval = modalPledgeValues?.RequestId;
    const transactionType = (() => {
        if (!modalPledgeValues) return;

        if (fromApproval) {
            return undefined;
        } else {
            return pledgeType;
        }
    })();

    const renderFailureText = () => {
        switch (transactionType) {
            case PledgeTransactionTypeEnum.new_pledge:
                return (
                    <>
                        <Typography
                            align='center'
                            className={`${classes.paddedText} ${classes.submitText}`}
                            variant='h5'
                        >
                            Your post was unable to be processed.
                        </Typography>
                        <Typography
                            align='center'
                            className={`${classes.smallPaddedText} ${classes.disclaimerText}`}
                            variant='body1'
                        >
                            Please check the details of your post, such as account information and amount, and try again,
                            or contact {email} or {phoneDirect || phoneTollFree || 'support line'} for assistance.
                        </Typography>
                    </>
                );
            case PledgeTransactionTypeEnum.pledge_add_on:
                return (
                    <>
                        <Typography
                            align='center'
                            className={`${classes.paddedText} ${classes.submitText}`}
                            variant='h5'
                        >
                            Your post add on was unable to be processed.
                        </Typography>
                        <Typography
                            align='center'
                            className={`${classes.smallPaddedText} ${classes.disclaimerText}`}
                            variant='body1'
                        >
                            Please check the details of your post add on, such as account information and amount, and try again,
                            or contact {email} or {phoneDirect || phoneTollFree || 'support line'} for assistance.
                        </Typography>
                    </>
                );
            case PledgeTransactionTypeEnum.reclaim:
                return (
                    <>
                        <Typography
                            align='center'
                            className={`${classes.paddedText} ${classes.submitText}`}
                            variant='h5'
                        >
                            Your reclaim was unable to be processed.
                        </Typography>
                        <Typography
                            align='center'
                            className={`${classes.smallPaddedText} ${classes.disclaimerText}`}
                            variant='body1'
                        >
                            Please check the details of your reclaim, such as account information and amount, and try again,
                            or contact {email} or {phoneDirect || phoneTollFree || 'support line'} for assistance.
                        </Typography>
                    </>
                );
            case PledgeTransactionTypeEnum.release:
                return (
                    <>
                        <Typography
                            align='center'
                            className={`${classes.paddedText} ${classes.submitText}`}
                            variant='h5'
                        >
                            Your release was unable to be processed.
                        </Typography>
                        <Typography
                            align='center'
                            className={`${classes.smallPaddedText} ${classes.disclaimerText}`}
                            variant='body1'
                        >
                            Please check the details of your release, such as account information and amount, and try again,
                            or contact {email} or {phoneDirect || phoneTollFree || 'support line'} for assistance.
                        </Typography>
                    </>
                );
            default:
                return (
                    <Typography
                        align='center'
                        className={classes.paddedText}
                        variant='body1'
                    >
                        Your request was unable to be processed.
                    </Typography>
                );
        }
    };

    if (!modalPledgeValues) return <div />;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='column'
            spacing={0}
        >
            {renderFailureText()}
            <Grid
                className={classes.buttonContainer}
                container
                direction='row'
                item
                justifyContent='center'
                spacing={0}
            >
                <BasicButton
                    onClick={onClose}
                    text='DONE'
                    type='main'
                />
            </Grid>
        </Grid>
    );
}

const PledgeResultFailed = withStyles(muiStyles)(PledgeResultFailedComponent);
export { PledgeResultFailed };